document
  .querySelectorAll<HTMLElement>('[data-collapse-toggle]')
  .forEach(trigger => {
    // get element to toggle
    const targetId = trigger.dataset.collapseToggle
    if (!targetId) return

    const target = document.getElementById(targetId)
    if (!target) return

    const setHidden = (hidden: boolean) => {
      target.setAttribute('aria-expanded', hidden ? 'false' : 'true')
    }

    // trigger is button
    if (trigger instanceof HTMLButtonElement) {
      trigger.addEventListener('click', () => {
        const isHidden = target.getAttribute('aria-expanded') === 'false'
        setHidden(!isHidden)
      })
    }

    // trigger is checkbox
    if (trigger instanceof HTMLInputElement && trigger.type === 'checkbox') {
      setHidden(!trigger.checked)

      trigger.addEventListener('change', () => {
        setHidden(!trigger.checked)
      })
    }
  })
